import {useCallback} from 'react'

import {OptimizedSchedule} from '../../../interfaces/api'
import {selectScheduleItemsFrom} from '../../../selectors/optimizer'
import {MomentRange} from '../../../selectors/time'
import {usePeriodicAutofillCheck} from '../../usePeriodicAutofillCheck'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

interface OptimizedScheduleQueryParams {
  scheduleId?: number | undefined
  isDisabled?: boolean
  throwOnError?: boolean
  range: MomentRange
}

export const useOptimizedScheduleQuery = ({
  scheduleId,
  isDisabled = false,
  throwOnError = true,
  range: [startOfPlan]
}: OptimizedScheduleQueryParams) => {
  const plantCode = useUrlParam('plantCode')

  // schedule is reloaded if there is a change in the autofill status
  usePeriodicAutofillCheck()

  const selector = useCallback(
    ({optimizedSchedules}: {optimizedSchedules: OptimizedSchedule[]}) => {
      // Since in "/optimized" endpoint BE includes also schedules for ± 1 day around the plan range,
      // we need to filter out old schedule items that are no longer relevant.
      return selectScheduleItemsFrom(optimizedSchedules, startOfPlan).find(
        (schedule) => schedule.scheduleId === scheduleId
      )
    },
    [scheduleId, startOfPlan]
  )

  return usePlannerQuery('optimizerRunsAndSchedules', [{plantCode}], {
    enabled: !isDisabled && scheduleId !== undefined,
    throwOnError,
    select: selector
  })
}
